module.exports = __webpack_public_path__ + "img/Slide30.69f1cf8c.png";